import type { SVGProps } from "react";

const IconPause = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path fill="currentColor" d="M6 3h2v18H6zm10 0h2v18h-2z" />
    </svg>
  );
};

export default IconPause;
